import {deserialize} from 'libs/cerialize';

export class ActiveSessionUserDto {
    @deserialize
    UserName: string;

    @deserialize
    LoginDate: string;
}
